import { Box, Typography } from '@material-ui/core'
import { formatPrice } from 'utils/format'
import {
  Header as GoalsTableHeader
} from 'components/GoalWizard/GoalsTable/styles'
import { BulkGoalClasses, BulkStore, StoreGoalConfig } from '../../types'
import { getDerivedMonthGoals } from '../../utils'

interface ReviewStepProps {
  classes: BulkGoalClasses
  selectedAvailableStores: BulkStore[]
  selectedMonthLabel: string
  storeGoalConfigs: StoreGoalConfig[]
}

const ReviewStep = ({
  classes,
  selectedAvailableStores,
  selectedMonthLabel,
  storeGoalConfigs
}: ReviewStepProps) => (
  <div className={classes.stepContainer}>
    <h1 className={classes.title}>Revisão das metas em lote</h1>
    <Typography className={classes.subtitle}>
      Confira as informações antes de criar as metas.
    </Typography>

    <div className={classes.reviewGrid}>
      <div className={classes.reviewCard}>
        <Typography color='textSecondary' variant='caption'>Mês</Typography>
        <Typography variant='h6'>{selectedMonthLabel}</Typography>
      </div>
      <div className={classes.reviewCard}>
        <Typography color='textSecondary' variant='caption'>Lojas</Typography>
        <Typography variant='h6'>{selectedAvailableStores.length}</Typography>
      </div>
      <div className={classes.reviewCard}>
        <Typography color='textSecondary' variant='caption'>Vendedores</Typography>
        <Typography variant='h6'>{storeGoalConfigs.reduce((acc, config) => acc + config.usersWorking.filter(user => user.active).length, 0)}</Typography>
      </div>
    </div>

    {storeGoalConfigs.length > 0 && (
      <Box mt={3} className={classes.guideBox}>
        <GoalsTableHeader>
          <div className='table-header-info'>
            <h1>Metas que serão criadas por loja</h1>
          </div>
        </GoalsTableHeader>
        <div className={classes.reviewTableWrapper}>
          <table className={classes.reviewTable}>
            <thead>
              <tr>
                <th>Loja</th>
                <th>Meta do mês</th>
                <th>Metas individuais dos vendedores</th>
              </tr>
            </thead>
            <tbody>
              {storeGoalConfigs.map(storeConfig => {
                const activeUsers = storeConfig.usersWorking.filter(user => user.active)
                const monthGoals = getDerivedMonthGoals(storeConfig)
                return (
                  <tr key={storeConfig.storeId}>
                    <td>
                      <div className={classes.reviewStoreName}>
                        <strong>{storeConfig.storeName}</strong>
                        <span>{activeUsers.length} vendedores participantes</span>
                      </div>
                    </td>
                    <td>
                      <span className={classes.reviewMonthGoal}>
                        {formatPrice(Number(storeConfig.total || 0))}
                      </span>
                      <br />
                      <span style={{ fontSize: 11, color: '#7b8b93' }}>
                        TM {formatPrice(Number(storeConfig.ticket || 0))} · PM {formatPrice(Number(storeConfig.price || 0))}
                      </span>
                    </td>
                    <td>
                      <div className={classes.reviewProfilesList}>
                        {monthGoals.map(goal => (
                          <div className={classes.reviewProfileItem} key={`${storeConfig.storeId}-${goal._id}`}>
                            <span className={classes.reviewProfileName}>{goal.name}</span>
                            <span className={classes.reviewProfileValues}>
                              <strong>{formatPrice(goal.value)}</strong>
                            </span>
                          </div>
                        ))}
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </Box>
    )}
  </div>
)

export default ReviewStep
